<mf-row>
  <mf-field-check
    [label]="gridFilter.header"
    [(ngModel)]="value" />
</mf-row>
